export default __webpack_public_path__ + "static/media/view-icon.88635834.svg";